import PropTypes from 'prop-types';
import React, { useRef } from 'react';

import { ReactComponent as Arrow } from '../../images/icons/fs-lc-arrow.svg';
import * as s from './Links.module.scss';
import SmartLink from './SmartLink';

const ArrowLink = ({
  inheritColor,
  url,
  isDownload,
  label,
  onClick,
  className = '',
  isLarge = false,
  isArrowDown = false,
  isArrowUp = false,
  isArrowLeft = false,
  isExternal = false,
  hoverAnimation = false,
  inlineArrow = false,
  isJumpLink = false,
}) => {
  const containerRef = useRef(null);

  const classes = [
    isLarge ? s.arrowLinkLarge : s.arrowLink,
    className,
    'cta',
    hoverAnimation ? s.bounceArrow : '',
    inheritColor ? s.inheritColor : '',
  ].join(' ');
  let arrowDirection = <Arrow />;
  if (isArrowDown) {
    arrowDirection = <Arrow className={s.arrowDown} />;
  } else if (isArrowUp) {
    arrowDirection = <Arrow className={s.arrowUp} />;
  } else if (isArrowLeft) {
    arrowDirection = <Arrow className={s.arrowLeft} />;
  }

  return (
    <SmartLink
      to={url}
      onClick={onClick}
      ref={containerRef}
      className={classes}
      download={isDownload}
      isExternal={isExternal}
      isJumpLink={isJumpLink}
      data-analytics-id={label}
    >
      <span className={inlineArrow ? s.inline : ''}>
        {isArrowLeft && arrowDirection}
        {label}
        {!isArrowLeft && arrowDirection}
      </span>
    </SmartLink>
  );
};

const PrimaryLink = ({
  url,
  onClick,
  label,
  isButton = false,
  backgroundColor,
  expand,
  className = '',
  id = '',
  outlined = false,
  slideIn = false,
  handleSlide,
  ...rest
}) => {
  let buttonClass = backgroundColor === 'white' ? s.outlinedButton : s.primaryButton;
  if (backgroundColor === 'pink') {
    buttonClass = s.pinkButton;
  } else if (backgroundColor === 'purple') {
    buttonClass = s.purpleButton;
  }

  if (expand) {
    buttonClass = `${buttonClass} ${s.expand}`;
  }
  const classes = [isButton ? buttonClass : s.primaryLink, outlined ? s.outlinedButton : '', className, 'cta'].join(
    ' '
  );

  if (slideIn) {
    return (
      <a
        onClick={() => handleSlide(url)}
        id={id}
        className={classes}
        data-analytics-component={'slide-in-link'}
        data-analytics-id={url}
      >
        {label}
      </a>
    );
  }

  return (
    <SmartLink
      data-analytics-component={'link'}
      data-analytics-id={'url'}
      to={url}
      onClick={onClick}
      id={id}
      className={classes}
      {...rest}
    >
      {label}
    </SmartLink>
  );
};

const sharedProps = {
  url: PropTypes.string,
  label: PropTypes.string.isRequired,
};

ArrowLink.propTypes = {
  isLarge: PropTypes.bool,
  isArrowDown: PropTypes.bool,
  isArrowUp: PropTypes.bool,
  isExternal: PropTypes.bool,
  ...sharedProps,
};

PrimaryLink.propTypes = {
  isButton: PropTypes.bool,
  id: PropTypes.string,
  ...sharedProps,
};

export { ArrowLink, PrimaryLink };
